import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'custom-toggle',
    styles: [`

    `],
    template: `
        <ion-row>
            <ion-label>{{to.label}}</ion-label>
        </ion-row>
        <ion-item lines="none">
            <ion-label>{{to.disabled ? 'Not Applicable' : (checked ? to.onText: to.offText) }}</ion-label>
            <ion-toggle  slot="start" color="primary"
                [formControl]="formControl"
                [formlyAttributes]="field"
                [disabled]="to.disabled" 
                [checked] = "to.checked"
                (ionChange)="updateFormValue($event)">
            </ion-toggle>
        </ion-item>
       
    `,
    standalone: false
})

export class CustomToggleFormlyType extends FieldType {
  checked: boolean;
  constructor() {
    super();
  }
  ngOnInit() {
    this.checked = this.to.checked;
  }
  updateFormValue(event) {
    this.checked = !this.checked;
    this.formControl.setValue(this.checked);
  }

}
